export default __webpack_public_path__ + "static/media/login-image-entrepreneurs.6a766df5.png";